
import { ASIFeature } from "@dndModels";
import { AbilityScoreExpandedType } from "@dndModels/Types";

/**
 * This is a simple increasing of an Ability Score.
 * It has an amount and options.  
 * If the options only has one in it, then it automatically uses it.
 */
export class CharacterASIFeature {
  true_id = ""; // The true_id of the asi_feature
  // id: number = -1;
  amount = 1;
  selected_option: AbilityScoreExpandedType = "None";

  constructor(obj?: any) {
    if (obj) {
      this.true_id = obj.true_id ? obj.true_id : "";
      // this.id = obj.id ? obj.id : -1;
      this.amount = obj.amount !== undefined ? obj.amount : 1;
      this.selected_option = obj.selected_option ? obj.selected_option : "None";
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      amount: this.amount,
      selected_option: this.selected_option
    };
  }

  copy(copyMe: CharacterASIFeature): void {
    this.true_id = copyMe.true_id;
    // this.id = copyMe.id;
    this.amount = copyMe.amount;
    this.selected_option = copyMe.selected_option;
  }

  clone() {
    const new_obj = new CharacterASIFeature();
    new_obj.copy(this);
    return new_obj;
  }

  copyASIFeature(copyMe: ASIFeature): void {
    this.true_id = copyMe.true_id;
    // this.id = copyMe.id;
    this.amount = copyMe.amount;
    this.selected_option = "None";
    console.log(copyMe);
    console.log(this.clone());
    if (copyMe.options.length === 1) {
      this.selected_option = copyMe.options[0];
    }
  }
}